import React, { useState, useEffect } from 'react';
import PromotionalBanner from './PromotionalBanner';
import './PromotionalBannerSlider.css';

const PromotionalBannerSlider = ({ promotions }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Filter only featured promotions
  const featuredPromotions = promotions.filter(promo => promo.featured);

  // Auto-rotate every 8 seconds
  useEffect(() => {
    if (featuredPromotions.length <= 1) {
      return;
    }

    const interval = setInterval(() => {
      handleNext();
    }, 8000);

    return () => clearInterval(interval);
  }, [currentIndex, featuredPromotions.length]);

  if (featuredPromotions.length === 0) {
    return null;
  }

  // If only one promotion, show it without controls
  if (featuredPromotions.length === 1) {
    return (
      <div className="container" style={{ marginTop: '2rem' }}>
        <PromotionalBanner promotion={featuredPromotions[0]} />
      </div>
    );
  }

  const handleNext = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev === featuredPromotions.length - 1 ? 0 : prev + 1));
      setIsTransitioning(false);
    }, 600);
  };

  const handlePrev = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex((prev) => (prev === 0 ? featuredPromotions.length - 1 : prev - 1));
      setIsTransitioning(false);
    }, 600);
  };

  const handleDotClick = (index) => {
    if (isTransitioning || index === currentIndex) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrentIndex(index);
      setIsTransitioning(false);
    }, 600);
  };

  return (
    <div className="container promotional-banner-slider" style={{ marginTop: '2rem' }}>
      <div className="slider-container">
        {/* All slides - only current one visible */}
        {featuredPromotions.map((promotion, index) => (
          <div
            key={promotion.id}
            className={`slider-slide ${index === currentIndex ? 'active' : ''} ${isTransitioning ? 'transitioning' : ''}`}
          >
            <PromotionalBanner promotion={promotion} disableAnimations={true} />
          </div>
        ))}

        {/* Navigation arrows */}
        <button
          onClick={handlePrev}
          className="slider-arrow slider-arrow-prev"
          disabled={isTransitioning}
        >
          <i className="fas fa-chevron-left"></i>
        </button>
        <button
          onClick={handleNext}
          className="slider-arrow slider-arrow-next"
          disabled={isTransitioning}
        >
          <i className="fas fa-chevron-right"></i>
        </button>

        {/* Dot indicators - using spans instead of buttons */}
        <div className="slider-dots">
          {featuredPromotions.map((_, index) => (
            <span
              key={index}
              onClick={() => handleDotClick(index)}
              className={`slider-dot ${index === currentIndex ? 'active' : ''}`}
              role="button"
              tabIndex={0}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>

        {/* Counter */}
        <div className="slider-counter">
          {currentIndex + 1} / {featuredPromotions.length}
        </div>
      </div>
    </div>
  );
};

export default PromotionalBannerSlider;
